import React from "react";

import "./infoCard.scss";

/**
 * Reusable colourful card — mirrors the Weekly Task Kanban card/column look:
 * a vivid gradient header (icon + title + optional actions) over a clean white
 * body. Drop-in replacement for a reactstrap <Card><CardBody>…</CardBody></Card>.
 *
 * Reuse this anywhere we want the "kanban colourful card" feel.
 *
 * Props:
 *  - title:        header text
 *  - icon:         remix-icon class (e.g. "ri-building-line")
 *  - accent:       colour key — indigo | blue | sky | violet | emerald | amber |
 *                  rose | teal | slate (default "indigo")
 *  - actions:      node rendered on the right side of the header
 *  - children:     body content
 *  - className:    extra class on the card
 *  - bodyClassName:extra class on the body
 *  - noPadding:    drop body padding (for tables / grids that pad themselves)
 */
export default function InfoCard({
  title,
  icon,
  accent = "indigo",
  actions,
  children,
  className = "",
  bodyClassName = "",
  noPadding = false,
}) {
  const hasHeader = title || icon || actions;

  return (
    <div className={`info-card info-card--${accent} ${className}`.trim()}>
      {hasHeader && (
        <div className="info-card__header">
          {icon ? <i className={icon} /> : null}
          {title ? <span className="info-card__title">{title}</span> : null}
          {actions ? <div className="info-card__actions">{actions}</div> : null}
        </div>
      )}
      <div
        className={`info-card__body${
          noPadding ? " info-card__body--flush" : ""
        } ${bodyClassName}`.trim()}
      >
        {children}
      </div>
    </div>
  );
}
